import React, { useEffect, useState } from "react";
import axios from "axios";

const ServiceClientData = () => {
  const [clientData, setClientData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [filters, setFilters] = useState({
    phone: "",
    email: "",
    startDate: "",
    endDate: "",
  });

  // Fetch data from the server
  const fetchData = async () => {
    try {
      const response = await axios.get(
        "https://mirai-server.vercel.app/service-client-data",
        {
          params: {
            page,
            limit: 3, // Items per page
            ...filters, // Include filters in the request
          },
        }
      );
      setClientData(response.data.data);
      setTotalPages(response.data.pages);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Fetch data whenever page or filters change
  useEffect(() => {
    fetchData();
  }, [page, filters]);

  // Handle filter changes
  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  // Apply filters and reset to the first page
  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setPage(1);
    fetchData();
  };

  // Handle "Next" and "Previous" button clicks
  const handleNext = () => {
    if (page < totalPages) setPage(page + 1);
  };

  const handlePrevious = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this item?"
    );
    if (!confirmDelete) return;

    try {
      const response = await axios.delete(
        `https://mirai-server.vercel.app/service-client-data/${id}`
      );
      if (response.data.deletedCount === 1) {
        alert("Item deleted successfully!");
        // Refresh the data for the current page
        fetchData();
      } else {
        alert("Failed to delete the item.");
      }
    } catch (error) {
      alert(`Error deleting item: ${error.message}`);
    }
  };

  return (
    <div>
      <div className="w-full py-6 border-b border-gray-300 px-6">
        <h1 className="text-2xl font-bold text-gray-700 font-roboto">
          Quotation Request
        </h1>
      </div>

      <div className="mx-6 mt-10">
        {/* Filter Form */}
        <form className="flex flex-row gap-5" onSubmit={handleFilterSubmit}>
          <input
            type="text"
            name="phone"
            placeholder="Phone"
            className="h-10 w-full rounded border border-gray-600 font-roboto text-xl text-gray-600"
            value={filters.phone}
            onChange={handleFilterChange}
          />
          <input
            type="email"
            name="email"
            className="h-10 w-full rounded border border-gray-600 font-roboto text-xl text-gray-600"
            placeholder="Email"
            value={filters.email}
            onChange={handleFilterChange}
          />
          <input
            type="date"
            name="startDate"
            className="h-10 w-full rounded border border-gray-600 font-roboto text-xl text-gray-600"
            value={filters.startDate}
            onChange={handleFilterChange}
          />
          <input
            type="date"
            name="endDate"
            className="h-10 w-full rounded border border-gray-600 font-roboto text-xl text-gray-600"
            value={filters.endDate}
            onChange={handleFilterChange}
          />
          <button
            className="w-full rounded h-10 flex justify-center items-center bg-gray-600 font-roboto text-white"
            type="submit"
          >
            Apply Filters
          </button>
        </form>

        <div class="relative overflow-x-auto mt-5 border border-gray-200 rounded">
          <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th
                  scope="col"
                  class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
                >
                  #
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
                >
                  Full Name
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
                >
                  Company Name
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
                >
                  Email
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
                >
                  Phone
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
                >
                  Service
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
                >
                  Budget
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
                >
                  Preferred Start Date
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
                >
                  Delete
                </th>
              </tr>
            </thead>
            {/* Data Display */}
            {clientData.length > 0 ? (
              clientData.map((client, index) => (
                <tbody>
                  <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                    <th
                      scope="row"
                      class="px-6 py-4 text-lg font-roboto text-gray-600   whitespace-nowrap dark:text-white"
                    >
                      {index + 1}
                    </th>
                    <td class="px-6 py-4 text-lg font-roboto text-gray-600">
                      {client.fullName}
                    </td>
                    <td class="px-6 py-4 text-lg font-roboto text-gray-600">
                      {client.companyName}
                    </td>
                    <td class="px-6 py-4 text-lg font-roboto text-gray-600">
                      {client.email}
                    </td>
                    <td class="px-6 py-4 text-lg font-roboto text-gray-600">
                      {client.phone}
                    </td>
                    <td className="px-6 py-4 text-lg font-roboto text-gray-600">
            <ul>
              {Object.entries(client.serviceType).map(([service, value], idx) => (
                <li key={idx}>
                  {service}: {value ? 'Yes' : value === false ? 'No' : value}
                </li>
              ))}
              {client.serviceType.other && client.serviceType.other !== "" && (
                <li>Other: {client.serviceType.other}</li>
              )}
            </ul>
          </td>
                    <td class="px-6 py-4 text-lg font-roboto text-gray-600">
                      {client.budgetRange}
                    </td>
                    <td class="px-6 py-4 text-lg font-roboto text-gray-600">
                      {new Date(client.preferredStartDate).toDateString()}
                    </td>
                    <td class="px-6 py-4 text-lg font-roboto text-gray-600">
                      <button onClick={() => handleDelete(client._id)}>
                        Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
              ))
            ) : (
              <p>No data found</p>
            )}
          </table>
        </div>

        {/* Pagination Controls */}
        <div style={{ marginTop: "20px" }}>
          <button
            className="text-xl font-semibold font-roboto hover:border-b border-gray-600 text-gray-600"
            onClick={handlePrevious}
            disabled={page === 1}
          >
            Previous
          </button>
          <span
            className="text-md text-gray-700 font-roboto"
            style={{ margin: "0 10px" }}
          >
            Page {page} of {totalPages}
          </span>
          <button
            onClick={handleNext}
            disabled={page === totalPages}
            className="text-xl font-semibold font-roboto hover:border-b border-gray-600 text-gray-600"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceClientData;
